import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux';

import primary3DIcon from '../../assets/img/3d_primary.png'
import "./css/apps.css"

import { IoNewspaperOutline } from "react-icons/io5";
import { useTitle } from '../../config/global';
import { Image } from 'react-bootstrap';
import Layout from '../Layout/Layout'
import { useNavT } from '../../nav/useNavT';
import { useEntitlements } from '../../hooks/useEntitlements';
import { TOOLS, visibleTools } from '../../nav/toolsCatalog';

const _apps = [
  {
    featureKey: "prayer_app",
    title: "Prayer",
    icon: <i className="fas fa-mosque fs-4"></i>,
    url: "/apps/prayer",
  },
  {
    featureKey: "live_meeting_access",
    title: "Broadcast ",
    icon: <i className="fas fa-broadcast-tower fs-4"></i>,
    url: "/apps/broadcast",
  },
  {
    featureKey: "rss_feed",
    title: "RSS Feeds ",
    icon: <i className="fa-solid fa-rss fs-4"></i>,
    url: "/apps/rss",
  },
  {
    featureKey: "rss_feed",
    title: "Custom RSS",
    icon: <IoNewspaperOutline className='fs-4' />,
    url: "/apps/rss/custom",
  },
  {
    featureKey: "3d",
    title: "Multi-media 3D Viewer",
    icon: <Image src={primary3DIcon} width="20" />,
    url: "/apps/3d/viewer",
  },
  {
    featureKey: "layouts",
    title: "Layouts",
    icon: <i className="fa-solid fa-pen-nib"></i>,
    url: "/apps/layouts",
  }
  ,
  {
    featureKey: "weather",
    title: "Weather",
    icon: <i className="fas fa-cloud-sun"></i>,
    url: "/apps/weather",
  },
  {
    featureKey: "clock",
    title: "Clock",
    icon: <i className="fas fa-clock"></i>,
    url: "/apps/clock",
  },
  {
    featureKey: "animated_layouts",
    title: "Animated Layouts",
    icon: <i className="fas  fa-magic"></i>,
    url: "/apps/animated_layouts",
  },
  {
    featureKey: "video_wall",
    title: "Video Wall",
    icon: <i className="fas fa-th-large fs-4"></i>,
    url: "/apps/video-wall",
  }

]

function Apps() {
  const { companyDetails, subscriptionInfo } = useSelector((state) => state.global);
  const nt = useNavT();
  const { has, features: pkgFeatures } = useEntitlements();
  useTitle(nt('nav6.item.tools', 'Apps'));

  var features = { ...companyDetails?.package?.features };
  var layers = companyDetails?.package?.features?.multiple_layer;
  const navigate = useNavigate()

  // (No-plan accounts never reach this page — CompanyDetailsRouter shows the
  // no-package state instead — so the old redirect to /profile is gone.)

  const appsTitle = nt('nav6.item.tools', 'Apps');
  const subNavbarProps = useMemo(() => {
    return {
      title: appsTitle,
    };
  }, [appsTitle]);

  // New navigation («أدوات الشاشة»): the same grid, only the tools the package includes (explicit false hides;
  // a missing key is shown, as everywhere). Off: every tile, with the Upgrade badge, exactly as before.
  const visibleApps = nt.on ? (() => { const open = new Set(visibleTools(has, pkgFeatures).map((x) => x.url)); return _apps.filter((app) => open.has(app.url)); })() : _apps;

  return (
    <Layout subNavbarProps={subNavbarProps}>

      {/* Discoverability over hiding — every app card renders regardless
          of plan; the inner page surfaces a FeatureLocked CTA when the
          backend 402s. Matches the menu visibility behavior set in
          commit 0426a2cf (Make gated features visible to all). */}
      <div className="row">
        {
          visibleApps?.map(app => {
            const unlocked = features?.[app.featureKey] || layers?.includes(app.featureKey);
            return (
              <Link
                key={app.url}
                to={app.url}
                className="col-12 col-md-6 col-lg-4 mb-4"
                style={{ textDecoration: 'none' }}
              >
                <div className="card h-100" style={{ position: 'relative' }}>
                  <div className="card-body">
                    <div className="card-title d-flex align-items-center justify-content-between flex-shrink-0 mb-0 ">
                      <div className='d-flex align-items-center '>
                        <span className="avatar-initial rounded bg-label-primary p-2 me-2">
                          {app.icon}
                        </span>
                        <div className='d-flex flex-column'>
                          <h5 className="fw-semibold my-0  ">{nt(TOOLS.find((x) => x.url === app.url)?.tk ?? 'nav6.tool.unknown', app.title)}</h5>
                          <small className=' text-capitalize'>  </small>
                        </div>
                      </div>
                      {!unlocked && (
                        <span
                          className="badge"
                          title="Upgrade to unlock"
                          style={{ background: '#94A3B8', color: '#fff', fontSize: 10 }}
                        >
                          <i className="pi pi-lock me-1" /> Upgrade
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>

    </Layout>
  )
}

export default Apps